export function setFooterMenuActive() {
    const menuLinks = document.querySelectorAll('.site-footer__menu_item');
    if (menuLinks.length === 0) {
        return;
    }
    menuLinks.forEach(link => {
        if (link.getAttribute('href') === window.location.href) {
            link.classList.add('active');
        }
    });
}
export function changeExpirationDateForReject() {
    var _a;
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }
    (_a = document.querySelector('.cky-btn-reject')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
        let cookieValue = getCookie('cookieyes-consent');
        setCookie('cookieyes-consent', cookieValue, 7);
    });
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
}
export function setRealViewportHeight() {
    const viewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--real-vh', `${viewportHeight * 0.01}px`);
}
export function playVideo() {
    const videoBlocks = document.querySelectorAll('.block-side-by-side__media');
    if (videoBlocks.length === 0) {
        return;
    }
    videoBlocks.forEach(videoBlock => {
        const btn = videoBlock.querySelector('.play_btn');
        const video = videoBlock.querySelector('video');
        btn.addEventListener('click', () => {
            btn.style.display = 'none';
            video.play();
        });
        video.addEventListener('click', () => {
            btn.style.display = 'flex';
            video.pause();
        });
    });
}
function showError(field, message) {
    var _a;
    const errorMessage = document.createElement('span');
    errorMessage.classList.add('error-message');
    errorMessage.textContent = message;
    (_a = field.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(errorMessage);
    field.classList.add('wpcf7-not-valid');
}
export function validateFirstName(field, message, minLength) {
    var _a, _b, _c;
    const previousError = (_a = field.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector('.error-message');
    if (previousError) {
        previousError.remove();
    }
    const hasDigits = /\d/.test(field.value);
    if (field.value.length < minLength && field.value.length > 0 || hasDigits) {
        showError(field, message);
        (_b = document.querySelector('input[type="submit"]')) === null || _b === void 0 ? void 0 : _b.classList.add('disabled-first-name');
    }
    else {
        (_c = document.querySelector('input[type="submit"]')) === null || _c === void 0 ? void 0 : _c.classList.remove('disabled-first-name');
    }
}
export function validateLastName(field, message, minLength) {
    var _a, _b, _c;
    const previousError = (_a = field.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector('.error-message');
    if (previousError) {
        previousError.remove();
    }
    const hasDigits = /\d/.test(field.value);
    if (field.value.length < minLength && field.value.length > 0 || hasDigits) {
        showError(field, message);
        (_b = document.querySelector('input[type="submit"]')) === null || _b === void 0 ? void 0 : _b.classList.add('disabled-last-name');
    }
    else {
        (_c = document.querySelector('input[type="submit"]')) === null || _c === void 0 ? void 0 : _c.classList.remove('disabled-last-name');
    }
}
